<template>
  <section class="wrap-service-overview">
    <div class="card">
      <p class="waiting-for-service-qantity">
        {{ dataServiceOverview.atendimentosAguardandoAtendimento }}
      </p>
      <p>Contatos aguardando atendimento</p>
    </div>
    <div class="card">
      <p class="unanswered-service-quantity">
        {{ dataServiceOverview.atendimentosSemResposta }}
      </p>
      <p>Em atendimento sem resposta</p>
    </div>
    <div class="card">
      <div class="info-month-day">
        <p>
          <span class="number-month-day">{{ dataServiceOverview.atendimentosEmAberto ? dataServiceOverview.atendimentosEmAberto.mes : 0 }}</span>
          <span> Mês </span>
        </p>
        <p>
          <span class="number-month-day">{{ dataServiceOverview.atendimentosEmAberto ? dataServiceOverview.atendimentosEmAberto.dia : 0 }}</span>
          <span> Dia </span>
        </p>
      </div>
      <p>
        Atendimentos em aberto
      </p>
    </div>
    <div class="card">
      <div class="info-month-day">
        <p>
          <span class="number-month-day">{{
            dataServiceOverview.atendimentosFinalizados ? dataServiceOverview.atendimentosFinalizados.mes : 0
          }}</span>
          <span> Mês </span>
        </p>
        <p>
          <span class="number-month-day">{{
            dataServiceOverview.atendimentosFinalizados ? dataServiceOverview.atendimentosFinalizados.dia : 0
          }}</span>
          <span> Dia </span>
        </p>
      </div>
      <p>
        Atendimentos finalizados
      </p>
    </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex"

export default {
  name: "ServiceOverview",
  computed: {
    ...mapGetters({
      dataServiceOverview: "dashboard/getDataServiceOverview",
    })
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/scss/app/components/serviceOverview";
</style>
